export default args => Math.max(...args);
